import PropTypes from 'prop-types';
import ReactSlider from 'react-slider';

import './style.scss';

const OpacitySlider = ({value, onChange}) => {
	return (
		<ReactSlider
			value={value}
			onChange={onChange}
			className="ptr-OpacitySlider"
			thumbClassName="ptr-OpacitySlider-thumb"
			trackClassName="ptr-OpacitySlider-track"
		/>
	);
};

OpacitySlider.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.number,
};

export default OpacitySlider;
